// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

/* eslint-disable */
import 'babel-polyfill';
import Vue from 'vue';
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import './theme/index.css';
import './style/font/iconfont.css'
import App from './App';
import router from './router';
import { urls, axios, store } from '@/common/index';
import Cookies from 'js-cookie';
import qs from 'qs';
import VueClipboard  from 'vue-clipboard2';
import VueLazyload from 'vue-lazyload';
import GlobalSocket from "@/common/utils/socket";

Vue.prototype.$globalSocket = new GlobalSocket("/api/guest/liveSocket", {
  pageType: "doMain",
  clientIp: (window.returnCitySN || {})["cip"] || "",
  inDomain: window.location.origin
});
// import VueAnalytics from 'vue-analytics'

// Vue.use(VueAnalytics, {
//   id: 'UA-135652521-1',
//   router
// })
Vue.use(VueLazyload);
Vue.use(VueClipboard);
Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.$api = axios;
Vue.prototype.$urls = urls;
Vue.prototype.$qs = qs;
Vue.prototype.$Cookies = Cookies;
var _hmt = _hmt || [];

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/pages/build08/build08.js